import React, { useEffect, useState } from "react";
import {
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Typography,
  Box,
  Divider,
  Stack,
} from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from "@mui/icons-material/Logout";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../router/axiosConfig";
import { useNavigate } from "react-router-dom";
import UserProfileModal from "../../pages/home/manageaccount/User/ProfileCard"; // Rename this file if needed

function UserProfile() {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [loggedUserDetail, setLoggedUserDetail] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => {
    navigate("/logout");
    handleClose();
  };

  const handleMyProfile = () => {
    setOpenModal(true);
    handleClose(); // Close menu when opening modal
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await api.get("getLoggedUserprofile");
        setLoggedUserDetail(response.data[0] || {});
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    fetchUserProfile();
  }, []);

  const getInitials = (name) =>
    name
      ?.split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase();

  return (
    <Box sx={{ marginBottom: 1 }}>
      <Tooltip title="User Profile" arrow>
        <IconButton onClick={handleClick} sx={{ p: 0 }}>
          <Avatar
            sx={{
              bgcolor: "#0abb87",
              width: 30,
              height: 30,
              mt: 1,
              fontSize: "0.9rem",
              fontWeight: 600,
            }}
          >
            {getInitials(loggedUserDetail?.userFullName || "U")}
          </Avatar>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        PaperProps={{
          elevation: 6,
          sx: {
            mt: 0,
            overflow: "visible",
            borderRadius: 3,
            minWidth: 260,
            filter: "drop-shadow(0px 3px 10px rgba(0,0,0,0.2))",

          },

        }}
        MenuListProps={{
          sx: { p: 0 }, // << FIXED: remove MenuList internal padding
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          sx={{
            px: 2,
            pt: '1.25',
            pb: 2,
            background: "linear-gradient(45deg, #0abb87, #1e4b8c)",
            color: "#fff",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            m: 0,

          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar sx={{ bgcolor: "#ffffff", color: "#0abb87", fontWeight: "bold" }}>
                {getInitials(loggedUserDetail?.userFullName || "U")}
              </Avatar>
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">
                  {loggedUserDetail?.userFullName || "User"}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {loggedUserDetail?.uRole || "Role"}
                </Typography>
              </Box>
            </Stack>
            <IconButton onClick={handleClose} sx={{ color: "#fff" }} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Box>

        <Divider />

        <MenuItem onClick={handleMyProfile} sx={{ py: 1.5 }}>
          <AccountCircleIcon fontSize="small" sx={{ mr: 1 }} />
          My Profile
        </MenuItem>

        <MenuItem onClick={handleLogout} sx={{ py: 1.5 }}>
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
          Sign Out
        </MenuItem>
      </Menu>


      <UserProfileModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        loggeduserdetail={loggedUserDetail}
      />
    </Box>
  );
}

export default UserProfile;
